import React from 'react';
import Layout from '../../components/Layout';

const MastersPage = () => (
  <Layout>
    <h2>Masters Page</h2>
  </Layout>
);

export default MastersPage; 